'use strict';
/*
 * HITUNG GALON — what a gallon count at a customer means, shared by the server and the browser.
 *
 * Staff count the gallons at the customer; the difference against the recorded balance is turned into a
 * plan (movement, ganti rugi, waived loss, or "still elsewhere"). The count sheet previews this plan and the
 * server writes exactly it. Both run THIS file, so the preview can never disagree with what is saved.
 *
 * Loaded as `window.DISTGL` in the browser bundle AND require()d by the server.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;   // server (CommonJS)
  if (root) root.DISTGL = api;                                                 // browser (global)
})(typeof globalThis !== 'undefined' ? globalThis : (typeof window !== 'undefined' ? window : this), function () {
  function num(v) { var n = Number(v); return isFinite(n) ? n : 0; }

  // key = what staff pick; legacy = the ADJ_REASONS value stored in the old `reason` column;
  // outsideOk = "galon masih di tempat lain" is a valid way to settle a shortfall for this reason.
  var COUNT_REASONS = [
    { key: 'pecah', legacy: 'galon_pecah_hilang', outsideOk: false },
    { key: 'dibawa', legacy: 'rekonsiliasi_fisik', outsideOk: true },
    { key: 'catatan_salah', legacy: 'salah_input', outsideOk: false },
    { key: 'belum_kembali', legacy: 'rekonsiliasi_fisik', outsideOk: true },
    { key: 'lainnya', legacy: 'lainnya', outsideOk: false }
  ];

  function reasonOf(key) {
    for (var i = 0; i < COUNT_REASONS.length; i++) if (COUNT_REASONS[i].key === key) return COUNT_REASONS[i];
    return null;
  }

  // o = { before, counted, reason (COUNT_REASONS key), shortfall: tagih|di_luar|tidak_ditagih|null,
  //       price (hargaGantiRugiGalon), canTagih (holds distribusiInput) }
  function planCount(o) {
    o = o || {};
    var before = num(o.before), price = num(o.price);
    var countedRaw = Number(o.counted);
    var r = reasonOf(o.reason);
    var plan = {
      diff: 0, short: 0, effect: 'none', movement: null, grKind: null, amount: 0, waive: false,
      outsideQty: 0, legacyReason: r ? r.legacy : null,
      allowed: { tagih: false, di_luar: false, tidak_ditagih: false }, blocked: null
    };
    if (o.counted == null || o.counted === '' || !isFinite(countedRaw) || countedRaw < 0 || Math.floor(countedRaw) !== countedRaw) {
      plan.diff = isFinite(countedRaw) ? countedRaw - before : 0;
      plan.blocked = 'NEGATIVE';
      return plan;
    }
    var diff = countedRaw - before, short = Math.max(0, -diff);
    plan.diff = diff; plan.short = short;
    plan.allowed = {
      tagih: !!o.canTagih && price > 0,
      di_luar: !!(r && r.outsideOk),
      tidak_ditagih: true
    };
    if (diff === 0) return plan;
    if (!r) { plan.blocked = 'REASON_REQUIRED'; return plan; }

    if (diff > 0) {
      plan.effect = 'penyesuaian';
      plan.movement = { type: 'penyesuaian', qty: diff };
      return plan;
    }

    var sf = o.shortfall;
    if (sf !== 'tagih' && sf !== 'di_luar' && sf !== 'tidak_ditagih') { plan.blocked = 'SHORTFALL_REQUIRED'; return plan; }
    if (sf === 'di_luar') {
      if (!r.outsideOk) { plan.blocked = 'OUTSIDE_REASON'; return plan; }
      plan.effect = 'outside'; plan.outsideQty = short;
    } else if (sf === 'tagih') {
      if (!o.canTagih) { plan.blocked = 'NO_GR_CAP'; return plan; }
      if (!(price > 0)) { plan.blocked = 'NO_PRICE'; return plan; }
      plan.effect = 'ganti_rugi';
      plan.grKind = r.key === 'pecah' ? 'pecah' : 'hilang';
      plan.amount = short * price;
    } else {
      plan.waive = true;
      if (r.key === 'catatan_salah') {
        plan.effect = 'penyesuaian';
        plan.movement = { type: 'penyesuaian', qty: -short };
      } else {
        plan.effect = 'loss_waived';
        plan.movement = { type: 'loss_customer', qty: short };
      }
    }
    return plan;
  }

  function dayNum(iso) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso || ''));
    return m ? Date.UTC(+m[1], +m[2] - 1, +m[3]) / 86400000 : NaN;
  }

  // 'never' (no count yet) | 'fresh' (under staleDays — whatever the limit, even above 60) | then, out of date:
  // 'gt60' (more than 60 days) | 'mid' (staleDays..60 days)
  function staleBucket(lastCountISO, todayISO, staleDays) {
    if (!lastCountISO) return 'never';
    var age = dayNum(todayISO) - dayNum(lastCountISO);
    if (!isFinite(age)) return 'never';
    if (age < num(staleDays)) return 'fresh';
    return age > 60 ? 'gt60' : 'mid';
  }

  // Running balance: each row's `delta` applied in order from `opening`.
  function historyBalance(rows, opening) {
    var bal = num(opening);
    return (rows || []).map(function (row) {
      bal += num(row && row.delta);
      var out = {};
      for (var k in row) if (Object.prototype.hasOwnProperty.call(row, k)) out[k] = row[k];
      out.balance = bal;
      return out;
    });
  }

  // How a ganti rugi transaction is paid, as ONE public key (doc-render GC_PAY / hg.pay* word it):
  // 'ganti_galon' (diganti galon baru) | 'transfer_pending' (transfer, bukti menyusul — booked as a bon until the
  // proof comes) | 'tunai' | 'transfer' | 'bon' | '' — never "bon" for a transfer that is only waiting for its proof.
  function grPayKey(t) {
    if (!t) return '';
    if (t.payMethod === 'ganti_galon') return 'ganti_galon';
    if (t.transferPending) return 'transfer_pending';
    if (t.payMethod === 'tunai' || t.payMethod === 'transfer') return t.payMethod;
    return t.method === 'bon' ? 'bon' : '';
  }

  return { COUNT_REASONS: COUNT_REASONS, planCount: planCount, staleBucket: staleBucket, historyBalance: historyBalance, grPayKey: grPayKey };
});
